export const AUTH_UNAUTHORIZED_EVENT = "auth:unauthorized";

export const dispatchUnauthorizedEvent = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(AUTH_UNAUTHORIZED_EVENT));
};

export const subscribeToUnauthorizedEvent = (handler) => {
  if (typeof window === "undefined") {
    return () => {};
  }

  window.addEventListener(AUTH_UNAUTHORIZED_EVENT, handler);

  return () => {
    window.removeEventListener(AUTH_UNAUTHORIZED_EVENT, handler);
  };
};
